<template>
  <bs-modal id="new_password" show-header dialog-centered>
    <template slot="modal-title">
      <h5 class="modal-title" id="exampleModalLabel">パスワード変更</h5>
    </template>

    <p>パスワードの変更を行います。</p>
    <div class="form_login">
      <label-input
        type="password"
        label="新しいパスワード（8桁以上）"
        v-model="newPassword"
        autocomplete="new-password"
      ></label-input>

      <div class="alert alert-danger mb-4" v-if="responseData.ngfg_newPassword">
        {{ responseData.msg_newPassword }}
      </div>

      <label-input
        type="password"
        label="新しいパスワード（確認）"
        v-model="checkPassword"
        autocomplete="new-password"
      ></label-input>

      <div
        class="alert alert-danger mb-4"
        v-if="responseData.ngfg_checkPassword"
      >
        {{ responseData.msg_checkPassword }}
      </div>

      <div class="text-center">
        <button
          type="submit"
          class="btn btn-lg btn-primary"
          @click="changePasswordHandler"
        >
          実行
        </button>
      </div>
    </div>
  </bs-modal>
</template>

<script>
export default {
  props: {
    userId: { type: String },
    isBeforeLogin: { type: Boolean, default: false }
  },
  data() {
    return {
      newPassword: "",
      checkPassword: "",
      responseData: {},
      hasError: false
    };
  },
  methods: {
    clearHandler() {
      this.newPassword = "";
      this.checkPassword = "";
      this.responseData = {};
      this.hasError = false;
    },

    async changePasswordHandler() {
      this.hasError = false;

      if (this.$props.isBeforeLogin) {
        await this.changePasswordActionBeforeLogin();
      } else {
        await this.changePassWordAction();
      }
    },

    async changePassWordAction() {
      const response = await this.postAsteria("Menu", "changePassword", {
        newPassword: this.newPassword,
        checkPassword: this.checkPassword
      });

      this.responseData = response.responseData;

      switch (response.responseData.return) {
        case 0:
          window.alert("パスワードを変更しました");
          this.$bootstrap.hideModal("new_password");
          break;
        case 1:
          this.hasError = true;
          break;
      }
    },

    async changePasswordActionBeforeLogin() {
      const response = await this.postAsteria("Login", "changePassword", {
        user_id: this.$props.userId,
        newPassword: this.newPassword,
        checkPassword: this.checkPassword
      });

      this.responseData = response.responseData;

      switch (response.responseData.return) {
        case 0:
          window.alert("パスワードを変更しました");
          this.$emit("changed", this.newPassword);
          this.$bootstrap.hideModal("new_password");
          break;
        case 1:
          this.hasError = true;
          break;
      }
    }
  }
};
</script>
